export const LS_AD_SESSION_KEY = 'ad-session';
export const LS_AD_TEST_PAGE_TYPE_KEY = 'ad-test-page-type';
export const LS_FEED_FILTERS_KEY = 'feed-filters';
export const LS_LOCALE_KEY = 'locale';
export const LS_PEOPLE_FILTERS_KEY = 'people-filters';
export const LS_QUICK_SEARCH_FILTERS_KEY = 'quick-search-filters';
export const LS_STATE_KEY = 'redux-state';

export const clearUserLocalStorageData = () => {
    localStorage.removeItem(LS_FEED_FILTERS_KEY);
    localStorage.removeItem(LS_PEOPLE_FILTERS_KEY);
    localStorage.removeItem(LS_QUICK_SEARCH_FILTERS_KEY);
    localStorage.removeItem(LS_STATE_KEY);
};
